<template>
    <div class="help">
        <div>
            <h2>Kit Builder Help</h2>

            <section>

            </section>
        </div>
    </div>
</template>

<script>
    export default {
        name: "help"
    }
</script>

<style lang="scss" scoped>
    .help {
        font-family: "Roboto", sans-serif;
        line-height: 1.9rem;
        padding: 25px 40px 0 40px !important;
        font-size: 0.9rem;

        section {
            margin-bottom: 3rem;
        }

        h2 {
            font-family: 'Sumana', serif;
            padding-bottom: 8px;
        }

        h3 {
            font-family: 'Sumana', serif;

            font-size: 1.5rem;
            border-bottom: 1px solid #E46A3B;
            padding-bottom: 8px;
            margin-bottom: 1.4rem;

            i {
                width: 30px;
                margin-right: 0.5rem;
            }
        }

        p {
            margin-bottom: 1.5rem;
        }

        h6 i {
            margin-right: 6px;
        }

        p, td, li {
            i {
                margin: 0 4px;
            }
        }

        ol li, ul li {
            margin-bottom: 15px;
            line-height: normal;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/app/store/help.vue